export default "<main-layout>\n    <router-outlet></router-outlet>\n    <dc-modal-layout></dc-modal-layout>\n</main-layout>\n"